import React, { useContext } from "react";
import {
  FormControl,
  TextField,
  CircularProgress,
  Autocomplete,
} from "@mui/material";
import { UserContext } from "../context/UserProvider";

const AccountSelector = ({
  label = "Select Account",
  selectedAccount,
  setSelectedAccount,
}) => {
  const { user: userData, loading: profileLoading } = useContext(UserContext);

  const accounts = userData?.accounts || [];

  return (
    <>
      {accounts.length > 0 && (
        <FormControl size="small" sx={{ minWidth: 220 }}>
          <Autocomplete
            size="small"
            options={accounts}
            value={selectedAccount || null}
            onChange={(_, newValue) => setSelectedAccount(newValue || "")}
            loading={profileLoading}
            disableClearable={false}
            isOptionEqualToValue={(option, value) => option === value}
            renderInput={(params) => (
              <TextField
                {...params}
                label={label}
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {profileLoading ? (
                        <CircularProgress color="inherit" size={16} />
                      ) : null}
                      {params.InputProps.endAdornment}
                    </>
                  ),
                }}
              />
            )}
          />
        </FormControl>
      )}
    </>
  );
};

export default AccountSelector;
